import React, { Component } from 'react';
import { Link } from "react-router-dom";

import UI from '../../../actions/ui-helper';

class ProntuarioReunioes extends Component {
  componentDidUpdate() {
    UI.dataTable("#dt-prontuario-b");
  }

  render() {
    let wrapStyle = {
      whiteSpace: "pre-wrap",
      fontSize: "12px"
    }

    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">ATIVIDADES / REUNIÕES</h4>
              <p className="card-description" />
              <div className="row">
                <div className="col-12 grid-margin">
                  <div className="row">
                    {this.props.reunioes && <div className="col-12 table-responsive">
                      <table id="dt-prontuario-b" className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Data</th>
                            <th>Horário</th>
                            <th>Procedimento</th>
                            <th>Profissional</th>
                            <th>Opções</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.reunioes.map((reuniao, i) => {
                            return (
                              <tr key={reuniao.id}>
                                <td>{reuniao.id}</td>
                                <td>{reuniao.data}</td>
                                <td>{reuniao.horaEntrada.substring(0, 5)} - {reuniao.horaSaida.substring(0, 5)}</td>
                                <td style={wrapStyle}>{reuniao.procedimento.codigo + " - " + reuniao.procedimento.descricao}</td>
                                <td style={wrapStyle}>
                                  {reuniao.valores.map((valor) => {
                                    return (<div
                                      key={valor.usuarioId}
                                      className="badge badge-default badge-gray badge-xs">{valor.usuarioNome}</div>)
                                  })}
                                </td>
                                <td>
                                  <div className="dropdown">
                                    <button className="btn btn-xs btn-light icon-btn btn-option" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      <i className="fa fa-cog"></i>
                                    </button>
                                    <div className="dropdown-menu">
                                      <Link
                                        to={"/reuniao/cadastro/" + reuniao.id}
                                        className="dropdown-item"><i className="fa fa-edit"></i>&nbsp;Editar</Link>
                                      <Link
                                        to={"/impressao/reuniao/" + reuniao.id}
                                        className="dropdown-item"><i className="fa fa-print"></i>&nbsp;Imprimir</Link>
                                      <span onClick={() => this.props.onExcluir(reuniao, i)} className="dropdown-item"><i className="fa fa-times"></i>&nbsp;Excluir</span>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>);
  }
}

export default ProntuarioReunioes;